import type { Unit } from '../shared/config';
import type {PublisherSignals} from '../shared/context';
import {mgid} from './mgid';
export async function banner(host: HTMLElement, unit: Unit, base: string, signals:PublisherSignals={},placement='in-article') {
  const fallback=unit.mgidFallback;
  const eligible=fallback?.enabled!==false&&fallback?.domains.includes(location.hostname);
  const widget=eligible?fallback?.widgets[placement]:undefined;
  if(eligible&&!widget)throw new Error('Unknown MGID placement');
  try { if(await requestBanner(host,unit,base,signals))return; }
  catch(error) {
    if(!widget)throw error;
    window.dispatchEvent(new CustomEvent('felixads:event',{detail:{unit:unit.id,event:'bannererror',message:String(error)}}));
  }
  if(widget&&fallback){
    mgid(host,{id:unit.id,type:'mgid',siteId:fallback.siteId,domains:fallback.domains,...widget});
    window.dispatchEvent(new CustomEvent('felixads:event',{detail:{unit:unit.id,event:'mgidfallback',widgetId:widget.widgetId}}));
  }else host.remove();
}
async function requestBanner(host: HTMLElement, unit: Unit, base: string, signals:PublisherSignals) {
  const response = await fetch(new URL('/api/bid',base), {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({unit:unit.id,page:location.href,ref:document.referrer,language:navigator.language,...signals}),signal:AbortSignal.timeout(6000)});
  window.dispatchEvent(new CustomEvent('felixads:event',{detail:{unit:unit.id,event:response.status===204?'nobid':'bidresponse',status:response.status,requestId:response.headers.get('X-FelixAds-Request-Id')}}));
  if (response.status===204) return false;
  if (!response.ok) throw new Error('Bridge request failed');
  const {adm} = await response.json();
  const frame=document.createElement('iframe'); frame.title='FelixAds 广告'; frame.width=String(unit.width); frame.height=String(unit.height);
  if(typeof adm!=='string'||adm.length>200000)throw new Error('Invalid creative');
  frame.setAttribute('sandbox','allow-scripts allow-popups'); frame.referrerPolicy='no-referrer'; frame.style.border='0';
  const schemes=location.protocol==='https:'?'https:':'https: http:';
  frame.srcdoc=`<!doctype html><meta charset="utf-8"><meta http-equiv="Content-Security-Policy" content="default-src ${schemes} data:; script-src ${schemes} 'unsafe-inline'; style-src 'unsafe-inline' ${schemes}; object-src 'none'; base-uri 'none'"><style>body{margin:0}</style>${adm}`;
  host.append(frame);
  return true;
}
